export default __webpack_public_path__ + "static/media/263.7744e403.gif";